<script>
import { Line } from "vue-chartjs";
export default {
    name: "area-chart",
    extends: Line,
    props: {
        chartData: Object,
        options: {
            type: Object,
            default: {},
        },
    },
    mounted() {
        this.renderChart(this.chartData, this.options);
    },
};
</script>
